import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {jwtDecode} from 'jwt-decode';
import JobCard from '../components/JobCard';
import { useParams } from 'react-router-dom';
import Sucessalert from '../components/sucessalert';

const UploadJob = () => {
    const { id } = useParams();
    const [jobs, setJobs] = useState([]);
    const [similarJobs, setSimilarjobs] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [role, setRole] = useState('seeker');
    const [isCompany, setIsCompany] = useState(false);
    const [deleteSuccess, setDeleteSuccess] = useState(false);
    const [formData, setFormData] = useState({
      jobTitle: '',
      jobType: 'Full-Time',
      location: '',
      salary: '',
      vacancies: '',
      experience: '',
    });
    const [desc, setDesc] = useState({
      requirements: '',
      desc: '',
    });
    
    useEffect(() => {
      const userToken = localStorage.getItem('token');
      const checkRole = localStorage.getItem('role');

      setRole(checkRole);
      if (userToken) {
        try {
          const decoded = jwtDecode(userToken);
          const userId = decoded.userId;
          if (userId === id) {
            setIsCompany(true);
          }
        } catch (error) {
          console.error('Error decoding token:', error);
        }
      }
    }, [id]);
  
    useEffect(() => {
      const fetchData = async () => {
        setIsLoading(true);
        try {
          let userId = id;
          if (!userId) {
            const userToken = localStorage.getItem('token');
            if (userToken) {
              try {
                const decoded = jwtDecode(userToken);
                userId = decoded.userId;
                
              } catch (error) {
                console.error('Token verification failed:', error.message);
              }
            }
          }
  
          if (userId) {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/job/job/${userId}`);
            setJobs(response.data);
            setFormData(response.data.data);
            if (Array.isArray(response.data.data.detail) && response.data.data.detail.length > 0) {
              setDesc(response.data.data.detail[0]);
            }
            setSimilarjobs(response.data.similarJobs);
          }
          setIsLoading(false);
        } catch (error) {
          console.error('Error fetching job listings:', error);
          setIsLoading(false);
        }
      };
      fetchData();
    }, [id]);
  
    const [errMsg, setErrMsg] = useState('');
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      const userToken = window.localStorage.getItem('token');
      if (!userToken) {
        setErrMsg('User token not found. Please log in.');
        return;
      }
  
      try {
        
        
  
        const response = await axios.put(
          `${process.env.REACT_APP_BACKEND_URL}/job/update-job/${id}`,
          { ...formData, ...desc },
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
            },
          }
        );
        console.log('Job uploaded successfully:', response.data);
        setDeleteSuccess(true);
  
        // Redirect to home page after success
        
      } catch (error) {
        console.error('Error uploading job:', error);
        setErrMsg('Error uploading job. Please try again later.');
      }
    };
  
    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData(prevState => ({ ...prevState, [name]: value }));
      console.log(isLoading,role,isCompany,jobs);
    };
    const handledesChange =(e) =>{
        const {name , value} = e.target;
        setDesc(prevState => ({...prevState , [name]:value}))
    }
  
 return (
    <div className="container mx-auto flex flex-col md:flex-row gap-8 2xl:gap-14 bg-[#f7fdfd] px-5">
      <div className="w-full h-fit md:w-2/3 2xl:2/4 bg-white px-5 py-10 md:px-10 shadow-md">
        <p className="text-gray-500 font-semibold text-2xl">Update Job Post</p>
        <form className="w-full mt-2 flex flex-col gap-8" onSubmit={handleSubmit}>
 <div className="flex flex-col">
    <label htmlFor="jobTitle" className="text-sm font-medium text-gray-700">Job Title</label>
    <input
      id="jobTitle"
      name="jobTitle"
      placeholder="eg. Software Engineer"
      type="text"
      value={formData.jobTitle}
      onChange={handleInputChange}
      className="w-full p-2 border border-gray-300 rounded"
    />
 </div>
 <div className="flex flex-col">
    <label htmlFor="jobType" className="text-sm font-medium text-gray-700">Job Type</label>
    <select
      id="jobType"
      name="jobType"
      value={formData.jobType}
      onChange={handleInputChange}
      className="w-full p-2 border border-gray-300 rounded"
    >
      <option value="Full-Time">Full-Time</option>
      <option value="Part-Time">Part-Time</option>
      <option value="Contract">Contract</option>
      <option value="Intern">Intern</option>
    </select>
 </div>
 <div className="flex flex-col">
    <label htmlFor="location" className="text-sm font-medium text-gray-700">Location</label>
    <input
      id="location"
      name="location"
      placeholder="eg. New York"
      type="text"
      value={formData.location}
      onChange={handleInputChange}
      className="w-full p-2 border border-gray-300 rounded"
    />
 </div>
 <div className="flex flex-col">
    <label htmlFor="salary" className="text-sm font-medium text-gray-700">Salary</label>
    <input
      id="salary"
      name="salary"
      placeholder="eg. 1500"
      type="number"
      value={formData.salary}
      onChange={handleInputChange}
      className="w-full p-2 border border-gray-300 rounded"
    />
 </div>
 <div className="flex flex-col">
    <label htmlFor="vacancies" className="text-sm font-medium text-gray-700">Vacancies</label>
    <input
      id="vacancies"
      name="vacancies"
      placeholder="eg. 3"
      type="number"
      value={formData.vacancies}
      onChange={handleInputChange}
      className="w-full p-2 border border-gray-300 rounded"
    />
 </div>
 <div className="flex flex-col">
    <label htmlFor="experience" className="text-sm font-medium text-gray-700">Experience</label>
    <input
      id="experience"
      name="experience"
      placeholder="eg. 2"
      type="number"
      value={formData.experience}
      onChange={handleInputChange}
      className="w-full p-2 border border-gray-300 rounded"
    />
 </div>
 <div className="flex flex-col">
    <label htmlFor="requirements" className="text-sm font-medium text-gray-700">Requirements</label>
    <textarea
      id="requirements"
      name="requirements"
      className='rounded border border-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 text-base px-4 py-2 resize-none'
      rows={4}
      cols={6}
      placeholder="eg. Technical skills, qualifications, etc."
      value={desc.requirements}
      onChange={handledesChange}
    />
 </div>
 <div className="flex flex-col">
    <label htmlFor="desc" className="text-sm font-medium text-gray-700">Description</label>
    <textarea
       className='rounded border border-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 text-base px-4 py-2 resize-none'
       rows={4}
       cols={6}
      id="desc"
      name="desc"
      placeholder="eg. Description text"
      value={desc.desc}
      onChange={handledesChange}
    />
 </div>
 <button
    type="submit"
    className="w-full p-2 bg-blue-500 text-white rounded hover:bg-blue-600"
 >
    Submit
 </button>
 {errMsg && (
    <span role="alert" className="text-sm text-red-500 mt-0.5">
      {errMsg}
    </span>
 )}
</form>

      </div>
      {/* Sidebar with recent job posts */}
<div className="w-full md:w-1/3 2xl:2/4 p-5 mt-20 md:mt-0">
        <p className="text-gray-500 font-semibold">Recent Job Post</p>
        <div className="w-full flex flex-wrap gap-6"> {Array.isArray(similarJobs) ? (
            
            similarJobs.slice(0,4).map((job) => (
              <JobCard job={job} key={job._id} profileUrl={job.company.profileUrl}   />
              
            ))
          ) : (
            <p>No jobs found</p>
          )}
        </div>
      </div>
       {/* Delete success popup */}
       {deleteSuccess && (
        <Sucessalert title={'Job Sucessfully update'} link={"/find-jobs"}
         text={`The Update Job feature allows users 
           to modify the details of an existing job listing`}/>
      )}
    </div>
    
    
 );
};

export default UploadJob;
